import React, { Component } from 'react';



export default class AnterosDropdownDivider extends Component {
     constructor(props,context) {
        super(props);
    }

    render() {
        return (<div className="dropdown-divider"></div>);
    }
}




// WEBPACK FOOTER //
// ./src/components/AnterosDropdownDivider.jsx